<template>
  <div id="app" class="not-received-report-page">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <hatadialog ref="hatadialog"></hatadialog>

    <v-app id="inspire" light>
      <v-card color="grey lighten-5" flat class="page-card">
        <v-layout row wrap>
          <v-flex xs12 md12 sm12>
            <v-toolbar dark color="info" class="page-toolbar">
              <v-toolbar-title>{{ $t('Report-of-Not-Received') }}</v-toolbar-title>
              <v-spacer></v-spacer>

              <v-menu bottom left offset-y>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>

                <v-list class="menu-list">
                  <v-list-tile @click="getListExcel()">
                    <v-list-tile-title>
                      Excel {{ $t('Download') }}
                    </v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </v-toolbar>
          </v-flex>

          <v-container fluid class="page-container">
            <v-form ref="formgunluksatis" v-model="valid" lazy-validation>
              <v-layout row wrap>
                <v-flex pb-3 xs12 sm12 md12>
                  <v-card flat class="filter-card">
                    <v-card-text class="pb-0">
                      <v-layout row wrap>
                        <v-flex xs12 sm6 pt-2 md2>
                          <v-select
                            :label="$t('Date-Type')"
                            item-value="value"
                            item-text="text"
                            :items="itemstarihtip"
                            v-model="tarihTip"
                            solo
                            flat
                            hide-details
                          ></v-select>
                        </v-flex>

                        <v-flex xs12 sm6 pt-2 md2>
                          <tarihcomp
                            :etiket="$t('Starting-Date')"
                            :detaygizle="false"
                            :rules="dateRules"
                            :defaultvalue="'ok'"
                            :value="KayitTarihiBasla"
                            v-model="KayitTarihiBasla"
                          ></tarihcomp>
                        </v-flex>

                        <v-flex xs12 pt-2 sm6 md2>
                          <tarihcomp
                            :etiket="$t('Finishing-Date')"
                            :detaygizle="false"
                            :rules="dateRules"
                            :defaultvalue="'ok'"
                            :value="KayitTarihiBitis"
                            v-model="KayitTarihiBitis"
                          ></tarihcomp>
                        </v-flex>

                        <v-flex xs12 pt-2 md2>
                          <div class="filter-actions">
                            <div v-if="load1">
                              <v-btn color="info" @click="getList()" fab small dark>
                                <v-icon>search</v-icon>
                              </v-btn>
                            </div>

                            <div v-if="progress" class="progress-wrap">
                              <v-progress-circular
                                indeterminate
                                :width="4"
                                color="blue"
                                size="28"
                              ></v-progress-circular>
                            </div>

                            <v-tooltip bottom>
                              <v-btn
                                slot="activator"
                                small
                                @click="filtrele()"
                                color="info"
                                fab
                                dark
                              >
                                <v-icon>filter_list</v-icon>
                              </v-btn>
                              <span>{{ $t('Add-Search-Filter') }}</span>
                            </v-tooltip>

                            <v-chip
                              v-if="filtrevarmi"
                              small
                              color="green"
                              text-color="white"
                              class="filter-chip"
                            >
                              <v-icon left small>check_circle_outline</v-icon>
                              {{ $t('Filter') }}
                            </v-chip>
                          </div>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>

                <v-flex xs12 sm12 md12 pb-3>
                  <ReportTable
                    :headers="headers"
                    :items="itemssatis"
                    :loading="progress"
                    :has-searched="hasSearched"
                    :storage-key="'faturasigelengelmeyen_report_table'"
                    :search-label="$t('Search')"
                    :show-frontend-export="true"
                    :rows-per-page-items="[20, 100]"
                    class="report-table-host"
                  >
                    <template slot="cell" slot-scope="slotProps">
                      {{ slotProps.value }}
                    </template>
                  </ReportTable>
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>

          <v-snackbar
            :timeout="timeout"
            :top="y === 'top'"
            :bottom="y === 'bottom'"
            :right="x === 'right'"
            :left="x === 'left'"
            :multi-line="mode === 'multi-line'"
            :vertical="mode === 'vertical'"
            v-model="snackbar"
          >
            {{ text1 }}
            <v-btn flat color="pink" @click="snackbar = false">
              {{ $t('Close') }}
            </v-btn>
          </v-snackbar>

          <v-dialog v-model="dialogfiltre" scrollable persistent max-width="500px">
            <v-card flat color="grey lighten-4">
              <v-card-title>{{ $t('Filter-selection') }}</v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout row wrap>
                  <v-flex xs12 sm6 md12 pa-1>
                    <v-card flat class="white--text">
                      <v-card flat color="grey lighten-5">
                        <v-card-actions>
                          <v-layout row wrap>
                            <v-flex xs12 sm12 md6>
                              <v-text-field
                                hide-details
                                v-model="RaporGelen.FaturaNo1"
                                :label="$t('Invoice-No') + '1'"
                              >
                              </v-text-field>
                            </v-flex>

                            <v-flex xs12 sm12 md6>
                              <v-text-field
                                hide-details
                                v-model="RaporGelen.FaturaNo2"
                                :label="$t('Invoice-No') + '2'"
                              >
                              </v-text-field>
                            </v-flex>

                            <v-flex md12 xs12 sm12>
                              <pnrbul v-model="RaporGelen.PNR_No" hide-details></pnrbul>
                            </v-flex>

                            <v-flex md12 xs12 sm12>
                              <cariaracomp
                                :etiket="$t('Currentcode_label')"
                                :value="RaporGelen.CariKod"
                                v-model="RaporGelen.CariKod"
                                :Coper="true"
                              ></cariaracomp>
                            </v-flex>

                            <v-flex md6 xs12 sm6>
                              <v-select
                                clearable
                                :items="itemssaticitip"
                                item-text="Aciklama"
                                item-value="Kod"
                                v-model="RaporGelen.SaticiTip"
                                :label="$t('Seller-Type')"
                                hide-details
                              >
                              </v-select>
                            </v-flex>

                            <v-flex xs12 sm6 md6>
                              <genelarama
                                :autofocuss="true"
                                apiname="SaticiAra"
                                :tip="RaporGelen.SaticiTip"
                                :label="$t('Seller-Code')"
                                v-model="RaporGelen.SaticiKod"
                              ></genelarama>
                            </v-flex>

                            <v-flex xs12 sm6 md6>
                              <v-radio-group v-model="RaporGelen.DurumKod">
                                <v-radio :label="$t('All-v2')" value="0"></v-radio>
                                <v-radio :label="$t('Invoiced-Ones')" value="1"></v-radio>
                                <v-radio :label="$t('Not-Invoiced-Ones')" value="2"></v-radio>
                                <v-radio :label="$t('With-Invoices')" value="3"></v-radio>
                                <v-radio :label="$t('Without-Invoices')" value="4"></v-radio>
                              </v-radio-group>
                            </v-flex>

                            <v-flex xs12 sm6 md6>
                              <v-radio-group v-model="RaporGelen.YurtIcDis">
                                <v-radio :label="$t('All-v2')" value="0"></v-radio>
                                <v-radio :label="$t('Domestic-v2')" value="1"></v-radio>
                                <v-radio :label="$t('Abroad')" value="2"></v-radio>
                              </v-radio-group>
                            </v-flex>

                            <v-flex xs12 sm12 md6>
                              <v-layout justify-space-between column>
                                <v-checkbox
                                  v-model="tumsirketler"
                                  :label="$t('All-Companies')"
                                  hide-details
                                ></v-checkbox>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-card-actions>
                      </v-card>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click="filtreiptal()">
                  {{ $t('cancel_button') }}
                </v-btn>
                <v-btn color="blue darken-1" flat @click="filtrekayit()">
                  {{ $t('Apply-Filters') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>
      </v-card>
    </v-app>
  </div>
</template>

<script>
import tarihcomp from "../../customcomp/tarihim";
import helpers from "@/components/app/customcomp/helpers.js";
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import tool from "../../coper/tools";
import hatadialog from "@/components/app/coper/comp/hatadialog.vue";
import rez from "../rezervasyon";
import genelarama from "@/components/app/coper/comp/genelarama.vue";
import pnrbul from "@/components/app/coper/component/pnrbul.vue";
import cariaracomp from "@/components/app/customcomp/cariaracomp.vue";
import ReportTable from "@/components/app/customcomp/ReportTable.vue";

function createHeaders(vm) {
  return [
    { text: vm.$t("Company-No"), value: "SirketNo", type: "text", align: "left", visible: true, sortable: true, minWidth: "120px" },
    { text: "PNR", value: "PNR_No", type: "text", align: "left", visible: true, sortable: true, minWidth: "130px" },
    { text: vm.$t("Name"), value: "Isim", type: "text", align: "left", visible: true, sortable: true, minWidth: "180px" },
    { text: vm.$t("Currentcode_label"), value: "CariKod", type: "text", align: "left", visible: true, sortable: true, minWidth: "140px" },
    { text: "Cari Ünvan", value: "CariUnvan", type: "text", align: "left", visible: true, sortable: true, minWidth: "220px" },
    { text: vm.$t("Situation-Code"), value: "DurumKod", type: "text", align: "left", visible: true, sortable: true, minWidth: "130px" },
    { text: vm.$t("Situation-Explanation"), value: "DurumAciklamasi", type: "text", align: "left", visible: true, sortable: true, minWidth: "180px" },
    { text: "Satış Fatura Tarih", value: "SatisFaturaTarih", type: "date", align: "left", visible: true, sortable: true, minWidth: "150px" },
    { text: "Satış Fat. Seri", value: "SatisFaturaSeri", type: "text", align: "left", visible: true, sortable: true, minWidth: "140px" },
    { text: "Satış Fat. No", value: "SatisFaturaNo", type: "text", align: "left", visible: true, sortable: true, minWidth: "140px" },
    { text: vm.$t("Sales-Currency-Type"), value: "SatisFaturaParaBirimi", type: "text", align: "left", visible: true, sortable: true, minWidth: "150px" },
    { text: vm.$t("Sales-Amount-v3"), value: "SatisTutar", type: "money", align: "right", visible: true, sortable: true, minWidth: "150px" },
    { text: "Satış Fat. Tutar", value: "SatisFaturaTutar", type: "money", align: "right", visible: true, sortable: true, minWidth: "150px" },
    { text: "Gelen Fat. Tarih", value: "GelenFaturaTarih", type: "date", align: "left", visible: true, sortable: true, minWidth: "150px" },
    { text: "Gelen Fat. Seri", value: "GelenFaturaSeri", type: "text", align: "left", visible: true, sortable: true, minWidth: "140px" },
    { text: "Gelen Fat. No", value: "GelenFaturaNo", type: "text", align: "left", visible: true, sortable: true, minWidth: "140px" },
    { text: "Gelen Fatura Tutar", value: "GelenFaturaTutar", type: "money", align: "right", visible: true, sortable: true, minWidth: "160px" },
    { text: "Komisyon Fat. Tarih", value: "KomisyonFaturaTarih", type: "date", align: "left", visible: true, sortable: true, minWidth: "160px" },
    { text: "Komisyon Fat. Seri", value: "KomisyonFaturaSeri", type: "text", align: "left", visible: true, sortable: true, minWidth: "150px" },
    { text: "Komisyon Fat. No", value: "KomisyonFaturaNo", type: "text", align: "left", visible: true, sortable: true, minWidth: "150px" },
    { text: vm.$t("Commission-Amount-v2"), value: "KomisyonTutar", type: "money", align: "right", visible: true, sortable: true, minWidth: "150px" },
    { text: "Komisyon Fat. Tutar", value: "KomisyonFaturaTutar", type: "money", align: "right", visible: true, sortable: true, minWidth: "160px" },
    { text: "Satıcı Tip", value: "SaticiTip", type: "text", align: "left", visible: true, sortable: true, minWidth: "140px" },
    { text: "Satıcı Kod", value: "SaticiKod", type: "text", align: "left", visible: true, sortable: true, minWidth: "140px" },
    { text: "Satıcı Ad", value: "SaticiAd", type: "text", align: "left", visible: true, sortable: true, minWidth: "180px" },
    { text: "Satıcı Cari", value: "SaticiCariKod", type: "text", align: "left", visible: true, sortable: true, minWidth: "150px" },
    { text: "Satıcı Cari Ünvan", value: "SaticiCariUnvan", type: "text", align: "left", visible: true, sortable: true, minWidth: "220px" },
    { text: "Gelen Fat. Satıcı Tip", value: "GelenFaturaSaticiTip", type: "text", align: "left", visible: true, sortable: true, minWidth: "170px" },
    { text: "Gelen Fat. Satici Ad", value: "GelenFaturaSaticiAd", type: "text", align: "left", visible: true, sortable: true, minWidth: "190px" },
    { text: "Gelen Fatura Satici Cari", value: "GelenFaturaCariKod", type: "text", align: "left", visible: true, sortable: true, minWidth: "190px" },
    { text: "Gelen Fatura Cari Unvan", value: "GelenFaturaCariUnvan", type: "text", align: "left", visible: true, sortable: true, minWidth: "220px" },
    { text: vm.$t("Tour-Operator"), value: "TurOperatoru", type: "text", align: "left", visible: true, sortable: true, minWidth: "170px" },
    { text: vm.$t("Expense-Center-v2"), value: "MasrafMerkezi", type: "text", align: "left", visible: true, sortable: true, minWidth: "150px" },
    { text: vm.$t("Expense-Centre-Name"), value: "MasrafMerkeziAdi", type: "text", align: "left", visible: true, sortable: true, minWidth: "200px" }
  ];
}

function beforeMount() {}

export default {
  name: "FaturasiGelenGelmeyenRaporu",
  beforeMount,
  components: {
    tarihcomp,
    yetkidialog,
    hatadialog,
    genelarama,
    pnrbul,
    cariaracomp,
    ReportTable
  },
  filters: {
    dateformat(t) {
      return helpers.dateformat(t);
    },
    moneyformat(m) {
      return helpers.moneyformat(m);
    },
    bakiyekontrol(m) {
      return helpers.bakiyekontrol(m);
    }
  },
  data() {
    return {
      headers: [],
      hasSearched: false,
      tumsirketler: false,
      itemssaticitip: rez.SaticiTip,
      itemsicdis: rez.IcDis,
      itemsopsiyon: rez.Opsiyon,
      itemstarihtip: [
        { text: this.$t("Invoice-Date"), value: 0 },
        { text: this.$t("Check-in-Date"), value: 1 },
        { text: this.$t("Check-out-Date"), value: 2 },
        { text: this.$t("Registration-Date"), value: 3 }
      ],
      itemskomisyon: [
        { text: this.$t("None"), value: false },
        { text: this.$t("Available"), value: true },
        { text: this.$t("All-v2"), value: null }
      ],
      tarihTip: 0,
      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0
      },
      filtrevarmi: false,
      search: "",
      searchsatilanbilet: null,
      searchiadebilet: null,
      searchvoid: null,
      headerssatis: [],
      Rapor: {
        PSirketNo: null,
        PCariSirket: null,
        PPNR_No: null,
        PPNR_ParaBirimi: "TL",
        PKayitTarihBas: null,
        PKayitTarihBit: null,
        PDonem1Bas: null,
        PDonem1Bit: null,
        PDonem2Bas: null,
        PDonem2Bit: null,
        PFatTarihBas: null,
        PFatTarihBit: null,
        PKomFatTarihBas: null,
        PKomFatTarihBit: null,
        PCariKod: null,
        PSaticiTip: null,
        PSaticiKod: null,
        PDosyaTip: null,
        PDosya: null,
        PAcente: null,
        PPNRBir: null,
        PCariHesapGrubu: null,
        PCariTip: null,
        PSaticiGrup: null,
        PSaticiIc_Dis: null,
        PTurOp: null,
        PFaturali: null,
        POpsiyon: null,
        PAnaTip: null,
        PCariAnaHesap: null,
        PIptalRaporu: null,
        PRezGrupID: null,
        PSatisGrubu: null,
        PSatisGrupTip: null,
        PSaticiOdemesiHesapla: null,
        PMasrafMerkezi: null,
        PAcenteDepartmanID: null,
        PPozisyonNo: null,
        PSatisFaturaNo: null,
        PMusteriOdemelilerHaric: null,
        PReferans: null,
        PSatisTip1: null,
        PSatisTip2: null,
        PSatisTip3: null,
        PSatisTip4: null,
        PGelenFatTarihBas: null,
        PGelenFatTarihBit: null,
        PProfilSablonId: null,
        PKomisyonFaturali: null,
        PGelenFaturali: null
      },
      RaporGelen: {
        Limit: 0,
        DurumKod: "0",
        FaturaTarih1: null,
        FaturaTarih2: null,
        GirisTarih1: null,
        GirisTarih2: null,
        CikisTarih1: null,
        CikisTarih2: null,
        KayitTarih1: null,
        KayitTarih2: null,
        FaturaNo1: null,
        FaturaNo2: null,
        PNR_No: null,
        CariKod: null,
        SaticiTip: 0,
        SaticiKod: null,
        YurtIcDis: "0"
      },
      KayitTarihiBasla: null,
      KayitTarihiBitis: null,
      itemsairlinelist: [],
      hesapgurubu: [],
      masrafmerkezi: [],
      doviztipi: [],
      valid: true,
      totalCount: 0,
      totalService: 0,
      totalAmount: 0,
      StartDate: null,
      EndDate: null,
      date: null,
      menu: false,
      modal: false,
      dateFormatted: "",
      date2: null,
      menu2: false,
      dateFormatted2: "",
      modal2: false,
      loading: false,
      items: [],
      load: false,
      load1: true,
      search3: "",
      renk1: "info",
      dialogfiltre: false,
      hesapkodu: [],
      kredikarti: [],
      statecari: [],
      searchcari: "",
      progress: false,
      yok: false,
      itemssatis: [],
      itemsiade: [],
      itemsvoid: [],
      butondurum: true,
      snackbar: false,
      y: "top",
      x: "right",
      mode: "",
      timeout: 6000,
      text1: "",
      dictionary: {
        custom: {
          tarihsec: {
            required: () => this.$t("Please-select-a-date")
          },
          tarihsec1: {
            required: () => this.$t("Please-select-a-date")
          }
        }
      }
    };
  },
  computed: {
    dateRules() {
      return [(v) => !!v || this.$t("Please-select-a-date")];
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.path;
    });
  },
  mounted() {
    this.headers = createHeaders(this);
    this.sayfayetki = helpers.pageScreenAuth(this.$route.name);

    if (this.sayfayetki.Status !== true) {
      this.$refs.yetkidialog
        .open(this.sayfayetki.Message, this.sayfayetki.islem)
        .then((sonuc) => {
          if (sonuc === true) {
            if (this.$validator && this.$validator.localize) {
              this.$validator.localize("en", this.dictionary);
            }

            if (this.prevRoute != null) {
              window.open("#" + this.prevRoute, "_self");
            } else {
              window.open("#/", "_self");
            }
          }
        })
        .catch(() => {});
    }
  },
  methods: {
    HataYonetimi(response, request, baslik) {
      if (response && response.status === 500) {
        this.$refs.hatadialog.open(response, request, baslik);
      } else {
        this.text1 = "Service Unavailable - " + baslik;
        this.snackbar = true;
      }
    },
    git() {},
    filtrele() {
      this.dialogfiltre = true;
    },
    filtrekayit() {
      this.filtrevarmi = true;
      this.dialogfiltre = false;
      this.getList();
    },
    filtreiptal() {
      this.filtrevarmi = false;
      this.dialogfiltre = false;
      this.RaporGelen.DurumKod = "0";
      this.RaporGelen.FaturaNo1 = null;
      this.RaporGelen.FaturaNo2 = null;
      this.RaporGelen.PNR_No = null;
      this.RaporGelen.CariKod = null;
      this.RaporGelen.SaticiTip = null;
      this.RaporGelen.SaticiKod = null;
      this.RaporGelen.YurtIcDis = "0";
      this.tumsirketler = false;
      this.getList();
    },
    applyDateFilterToReport() {
      if (this.tarihTip === 0) {
        this.RaporGelen.FaturaTarih1 = this.KayitTarihiBasla;
        this.RaporGelen.FaturaTarih2 = this.KayitTarihiBitis;
        this.RaporGelen.GirisTarih1 = null;
        this.RaporGelen.GirisTarih2 = null;
        this.RaporGelen.CikisTarih1 = null;
        this.RaporGelen.CikisTarih2 = null;
        this.RaporGelen.KayitTarih1 = null;
        this.RaporGelen.KayitTarih2 = null;
      } else if (this.tarihTip === 1) {
        this.RaporGelen.FaturaTarih1 = null;
        this.RaporGelen.FaturaTarih2 = null;
        this.RaporGelen.GirisTarih1 = this.KayitTarihiBasla;
        this.RaporGelen.GirisTarih2 = this.KayitTarihiBitis;
        this.RaporGelen.CikisTarih1 = null;
        this.RaporGelen.CikisTarih2 = null;
        this.RaporGelen.KayitTarih1 = null;
        this.RaporGelen.KayitTarih2 = null;
      } else if (this.tarihTip === 2) {
        this.RaporGelen.FaturaTarih1 = null;
        this.RaporGelen.FaturaTarih2 = null;
        this.RaporGelen.GirisTarih1 = null;
        this.RaporGelen.GirisTarih2 = null;
        this.RaporGelen.CikisTarih1 = this.KayitTarihiBasla;
        this.RaporGelen.CikisTarih2 = this.KayitTarihiBitis;
        this.RaporGelen.KayitTarih1 = null;
        this.RaporGelen.KayitTarih2 = null;
      } else if (this.tarihTip === 3) {
        this.RaporGelen.FaturaTarih1 = null;
        this.RaporGelen.FaturaTarih2 = null;
        this.RaporGelen.GirisTarih1 = null;
        this.RaporGelen.GirisTarih2 = null;
        this.RaporGelen.CikisTarih1 = null;
        this.RaporGelen.CikisTarih2 = null;
        this.RaporGelen.KayitTarih1 = this.KayitTarihiBasla;
        this.RaporGelen.KayitTarih2 = this.KayitTarihiBitis;
      }
    },
    validateDateRange() {
      if (!this.$refs.formgunluksatis.validate()) {
        return false;
      }

      const bastarih = new Date(this.KayitTarihiBasla);
      const bittarih = new Date(this.KayitTarihiBitis);

      if (bastarih <= bittarih) {
        return true;
      }

      this.text1 = this.$t("start-date-cannot-greater-than-end-date");
      this.snackbar = true;
      return false;
    },
    createReportParams() {
      this.applyDateFilterToReport();

      const RaporParam = {};
      RaporParam.Limit = this.RaporGelen.Limit;
      RaporParam.DurumKod = this.RaporGelen.DurumKod;
      RaporParam.FaturaTarih1 = this.RaporGelen.FaturaTarih1;
      RaporParam.FaturaTarih2 = this.RaporGelen.FaturaTarih2;
      RaporParam.GirisTarih1 = this.RaporGelen.GirisTarih1;
      RaporParam.GirisTarih2 = this.RaporGelen.GirisTarih2;
      RaporParam.CikisTarih1 = this.RaporGelen.CikisTarih1;
      RaporParam.CikisTarih2 = this.RaporGelen.CikisTarih2;
      RaporParam.KayitTarih1 = this.RaporGelen.KayitTarih1;
      RaporParam.KayitTarih2 = this.RaporGelen.KayitTarih2;
      RaporParam.FaturaNo1 = this.RaporGelen.FaturaNo1;
      RaporParam.FaturaNo2 = this.RaporGelen.FaturaNo2;
      RaporParam.PNR_No = this.RaporGelen.PNR_No;
      RaporParam.SaticiTip = this.RaporGelen.SaticiTip;
      RaporParam.YurtIcDis = this.RaporGelen.YurtIcDis;

      if (this.RaporGelen.CariKod != null) {
        RaporParam.CariKod = this.RaporGelen.CariKod.id;
      } else {
        RaporParam.CariKod = this.RaporGelen.CariKod;
      }

      if (this.RaporGelen.SaticiKod != null) {
        RaporParam.SaticiKod = this.RaporGelen.SaticiKod.kod;
      } else {
        RaporParam.SaticiKod = this.RaporGelen.SaticiKod;
      }

      RaporParam.tumSirketler = this.tumsirketler;
      RaporParam.sayfaAdi = this.$route.name;

      return RaporParam;
    },
    getList() {
      if (!this.validateDateRange()) {
        return;
      }

      this.hasSearched = true;
      this.progress = true;
      this.load1 = false;

      const params = this.createReportParams();

      tool.http_post(this, "FaturasiGelenGelmeyenRaporu", params)
        .then((response) => {
          if (response.body.Status === true) {
            this.itemssatis = response.body.data || [];
          } else {
            this.itemssatis = [];
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
          }
        })
        .catch((response) => {
          this.HataYonetimi(response, params, "Rapor Getirilemedi");
        })
        .then(() => {
          this.progress = false;
          this.load1 = true;
        });
    },
    getListExcel() {
      if (!this.validateDateRange()) {
        return;
      }

      this.progress = true;
      this.load1 = false;

      const params = this.createReportParams();

      tool.api_post_FileDownload(this, "Coper/ExcelFaturasiGelenGelmeyen", params)
        .then((response) => {
          tool.CreateDownloadLink(response, "CoperFaturasiGelenGelmeyen.xlsx");
        })
        .catch((response) => {
          this.HataYonetimi(response, params, "Satış Listesi Getirilemedi");
        })
        .then(() => {
          this.progress = false;
          this.load1 = true;
        });
    }
  }
};
</script>

<style scoped>
.not-received-report-page {
  min-height: 100vh;
  background: #f1f3f5;
}

.page-card {
  min-height: 100vh;
}

.page-toolbar {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
}

.page-container {
  padding-top: 22px;
}

.filter-card {
  background: #ffffff;
  border-radius: 4px;
}

.filter-actions {
  min-height: 48px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 10px;
}

.progress-wrap {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.filter-chip {
  margin-left: 0;
}

.report-table-host {
  width: 100%;
}

.menu-list {
  min-width: 340px;
}

@media (max-width: 960px) {
  .filter-actions {
    justify-content: flex-start;
  }
}
</style>